import { collection, onSnapshot, setDoc, doc, deleteDoc, updateDoc } from "firebase/firestore";
import { db } from "@/firebaseApp";
import uuid4 from "uuid4";

function projectSetup(getters, commit, service) {
    let projects = getters['projects/service'](service.id)
    for (let project of projects) {
        if (project.serviceName == service.name) {
            continue
        }
        project.serviceName = service.name
        commit("projects/add", project, { root: true })
    }
    return
}

const services = {
    namespaced: true,

    state: {
        all: [],
        service: null,
        unsubs: [],
    },

    getters: {
        id: (state) => (serviceId) => {
            return state.all.find(({ id }) => id == serviceId)
        },
    },

    mutations: {
        add(state, newService) {
            state.all.push(newService);
        },
        unsub(state) {

            while (state.unsubs.length) {
                let unsub = state.unsubs.pop()
                unsub()
            }
        },
        service(state, service) {
            state.service = service;
        },
        all(state, services) {
            state.all = services;
        },
        addUnsub(state, unsub) {
            state.unsubs.push(unsub)
        },
        delete(state, service) {
            const index = state.all.findIndex(({ id }) => service.id === id)
            if (index < 0) {
                return
            }
            state.all.splice(index, 1)
        },
    },

    actions: {
        async getAll({ commit, rootState, rootGetters }) {
            const instanceId = rootState.instanceId

            if (instanceId == null) return

            commit('unsub')

            try {
                let unsub = onSnapshot(collection(db, `instances/${instanceId}/services`), (querySnapshot) => {
                    querySnapshot.docChanges().forEach((change) => {
                        const doc = change.doc;
                        let data = doc.data()
                        let service = { ...data, id: doc.id }
                        projectSetup(rootGetters, commit, service)
                        switch (change.type) {
                            case 'added':
                                commit("delete", service);
                                commit("add", service);
                                break
                            case "removed":
                                commit("delete", service);
                                break;
                            default:
                                break;
                        }
                    })
                })
                commit('addUnsub', unsub)
            } catch (error) {
                console.log("ERROR TO GET ALL SERVICES: " + error);
            }
        },

        async create({ rootState }, { name, description }) {
            const instanceId = rootState.instanceId
            const serviceId = uuid4()

            if (instanceId == null) return

            try {
                await setDoc(doc(db, `instances/${instanceId}/services/${serviceId}`), {
                    name,
                    description
                })

            } catch (error) {
                console.log("ERROR TO CREATE SERVICES: " + error);
            }
        },

        async edit({ commit, rootState }, { service }) {
            const instanceId = rootState.instanceId
            try {
                const serviceRef = doc(db, `instances/${instanceId}/services`, service.id);
                await updateDoc(serviceRef, {
                    name: service.name,
                    description: service.description
                });
                commit('service', service)
            } catch (error) {
                console.log(error)
            }
        },

        async delete({ commit, rootState }, id) {
            const instanceId = rootState.instanceId

            try {
                const serviceRef = doc(db, `instances/${instanceId}/services`, id)
                await deleteDoc(serviceRef)
                commit('delete', id)

            } catch (error) {
                console.log('ERROR DELETING SERVICE', error)
            }
        },
    }
}

export default services
